// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_j4-0";